<template>
    <div class="footer">
      </div>
</template>

<style>
.footer {
  position: relative; 
  margin-left: auto;
  margin-right: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30vh;
  text-align: center;
  background-color: rgb(0, 0, 0);
  z-index: 3; 
  box-shadow: 10px 20px 10px rgba(0, 0, 0, 0.459);
}

</style>